import { render } from "./AccountView.vue?vue&type=template&id=d712a062&ts=true"
import script from "./AccountView.vue?vue&type=script&lang=ts"
export * from "./AccountView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__